import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';
import { ClipLoader } from 'react-spinners';

const TermsSection = () => {
  const [termsData, setTermsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTermsData();
  }, []);

  const fetchTermsData = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}home/info`);

      if (response.data.success) {
        setTermsData(response.data.data);
      } else {
        setError("Failed to fetch terms and conditions information");
      }
    } catch (err) {
      setError("Error fetching terms and conditions information");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Loading state
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
        }}
      >
        <ClipLoader size={45} />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <section className="about-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="innerbanner"></section>

      <section className="staticpagecontainer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {termsData?.terms_of_service ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: termsData.terms_of_service,
                  }}
                />
              ) : ( 
                <div className="text-center">
                  <p className="text-muted">
                    No terms and conditions content available yet.
                  </p>
                  <p>
                    These terms govern your use of our platform, services,
                    bookings, and interactions between guests and homestay
                    owners.
                  </p>
                  <p>
                    Please check back later for detailed terms related to
                    payments, cancellations, responsibilities, and legal
                    policies.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsSection;
